import { RootState } from 'store/store';

export const selectRecipes = (store: RootState) => store.recipes.list;

export const selectRecipe = (store: RootState, id?: string) => {
  if (id) {
    return store.recipes.list.find((item) => item.id === id);
  }
  return undefined;
};
